/* eslint-disable */
import Vue from 'vue'
import store from '@/store'
import * as Sentry from '@sentry/browser'

const api = {
  init(userID) {
    // Sentry DNS
    if (process.env.SENTRY_DNS !== '') {
      Sentry.init({ dsn: process.env.SENTRY_DNS, integrations: [new Sentry.Integrations.Vue({ Vue })] })
    }

    // Google Analytics
    if (process.env.GOOGLE_ANALYTICS !== '') {
      const google_analytics = document.createElement('script')
      google_analytics.setAttribute('src',`https://www.googletagmanager.com/gtag/js?id=${process.env.GOOGLE_ANALYTICS}`)
      document.head.appendChild(google_analytics)
      window.dataLayer = window.dataLayer || []
      function gtag() { dataLayer.push(arguments) }
      gtag('js', new Date())
      gtag('config', `${process.env.GOOGLE_ANALYTICS}`, { 'user_id': userID })
      console.log(`Google Analytics started user: ${userID}`)
    }

    // Yandex Metrika
    if (process.env.YANDEX_METRIKA !== '') {
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym")
      ym(process.env.YANDEX_METRIKA, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true,
          userParams: { UserID: userID }
      })
      console.log(`Yandex Metrika started user: ${userID}`)
    }

    // Announcekit
    // iFrame do not work on iOS
    if (process.env.ANNOUNCE_KIT !== '') {
      if (window.cordova !== undefined && device.platform === 'iOS') return
      const announce_kit = document.createElement('script')
      announce_kit.setAttribute('src','https://cdn.announcekit.app/widget.js')
      document.head.appendChild(announce_kit)
      window.announcekit = (window.announcekit || { queue: [], on: function(n, x) { window.announcekit.queue.push([n, x]); }, push: function(x) { window.announcekit.queue.push(x); } });
      window.announcekit.push({
        "widget": `https://announcekit.app/widget/${process.env.ANNOUNCE_KIT}`,
        "name": "announce",
        "version": 2,
      })
      window.announcekit.on("widget-unread", function({ widget, unread }) {
        store.dispatch('tools/setNewUnreadCount', unread)
      })
      console.log('Announce Kit started')
    }

    console.log('tools initialized')
  }
}

export default api


// WEBPACK FOOTER //
// ./src/services/tools.js